import React from 'react';
import { Card, Row, Col } from 'antd';
import { decryptTextByAES } from 'utils/encryption';
import SPFigureHidden from 'components/base/SPFigureHidden';

const DriverInfo:React.FC<any> = (props) => {

  const { data } = props || {};
  const { driver_customer } = data?.order_info || {};
  const { name, phone, id_card } = driver_customer || {};

  const getDefaultText = (text: string) => {
    return text || '--';
  }

  return (
    <>
      <Card title="驾驶人信息" style={{ marginBottom: 20 }}>
        <Row>
          <Col span={2}>驾驶人姓名:</Col><Col span={6}>
            <SPFigureHidden content={getDefaultText(name)} type="name" />
          </Col>
          <Col span={2}>驾驶人手机号:</Col><Col span={6}>
            <SPFigureHidden content={decryptTextByAES(phone)} />
          </Col>
          <Col span={2}>驾驶人身份证:</Col><Col span={6}>
            <SPFigureHidden content={decryptTextByAES(id_card)} type="idCard" />
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default DriverInfo;